let urlManager = {

    tempPath: false,

    addQuery: function(key, value) {
        value = value || null;
    },

    setQuery: function(key, value) {
        value = value || null;
    },

    parseQuery: function() {
        if (!this.tempPath) {
            this.tempPath = decodeURIComponent(location.search.substr(1));
        }

        let parts = this.tempPath.split('&');
        let pairs = {};
        parts.forEach(function(pair) {
            let pairParts = pair.split('=');

            let key = null;
            let value = null;
            if (pairParts.length == 1 && pairParts[0].trim().length) {
                key = pairParts[0].trim();
                value = true;
            } else if (pairParts.length == 2) {
                key = pairParts[0].trim();

                if (!pairParts[1].trim().length) {
                    value = true;
                } else {
                    value = pairParts[1].trim();
                }
            }

            if (key && value) {
                pairs[decodeURIComponent(key)] = decodeURIComponent(value);
            }
        });

        return pairs;
    },

    buildQuery: function(parts) {
        this.tempPath = Object.keys(parts).map(x => [encodeURIComponent(x), encodeURIComponent(parts[x])].join('=')).join('&');
        return this.tempPath;
    },

    updateURL: function(key, value) {
        value = value || null;
        let parts = this.parseQuery();
        parts[key] = value;

        if (null == value) {
            delete parts[key];
        }

        return this.buildQuery(parts);
    },

    setURL: function(key, value) {
        value = value || null;
        let parts = {};
        parts[encodeURIComponent(key)] = encodeURIComponent(value);

        if (null == value) {
            delete parts[key];
        }

        return this.buildQuery(parts);
    },

    updateAndGo: function(key, value) {
        value = value || null;
        location.search = this.updateURL(key, value);
    },

    setAndGo: function(key, value) {
        value = value || null;
        location.search = this.setURL(key, value);
    }

}

export default urlManager